export default __webpack_public_path__ + "static/health_b.684f85dfb63b7c62f382b1d4fe80b82e.svg";